angular.module('spaceChat.common')
   .factory('spaceChatArchiveSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var SpaceChatArchive = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/{resource}{id}{subResource}';
      this.businessArea = 'space-chat';
      this.resource = 'chat/archive';
    };

    return new SpaceChatArchive();
  }])
;